import { Chip, IconButton, Modal, NavigationTabs, styleClassNames, TNavigationTabLinkProps } from '@chocolate-soup-inc/cs-frontend-components';
import { ReactNode, useCallback, useEffect, useMemo } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import { TDeliveryMethod } from '../../generated/graphql';
import { ACCOUNT_PATH, DEPENDANTS_PATH, ENTITY_GIFTS_PATH } from '../../routes/paths';

import { useFilter } from '../../contexts/filters';
import { isAddressValid } from '../../entities/addresses/shared';
import { TEmployeeType } from '../../entities/employees/queries';
import styles from './EmployeeModal.module.scss';

type TEmployeeModalProps = {
  children: ReactNode;
  employee?: TEmployeeType;
  headline?: string;
};

export const EmployeeModal = (props: TEmployeeModalProps) => {
  const { filtersModalMode } = useFilter();
  useEffect(() => {
    filtersModalMode();
  }, []); // eslint-disable-line

  const { children, employee, headline } = props;

  const navigate = useNavigate();

  const closeModal = useCallback(() => {
    navigate(generatePath(`../../`));
  }, [navigate]);

  const options: TNavigationTabLinkProps[] = useMemo(() => {
    const opts: TNavigationTabLinkProps[] = [];

    if (employee && employee.id) {
      opts.push({
        label: 'Account',
        path: generatePath(`../${ACCOUNT_PATH}`)
      });

      if (employee.company && (employee.company.petBirthdayActivated || employee.company.childBirthdayActivated || employee.company.significantOtherBirthdayActivated))
        opts.push({
          label: 'Dependants',
          path: generatePath(`../${DEPENDANTS_PATH}`)
        });

      opts.push({
        label: 'Gifts',
        path: generatePath(`../${ENTITY_GIFTS_PATH}`)
      });
    }

    return opts;
  }, [employee]);

  return (
    <Modal contentClassName={styles.modal} closeModal={closeModal}>
      <div className={styles.employeeModal}>
        <div className={styles.titleWrapper}>
          <div className={styles.titleContainer}>
            {headline && <h1 className={styles.title}>{headline}</h1>}
            <div className={styles.chipsContainer}>
              {!isAddressValid(employee?.address) && employee?.company?.deliveryMethod === TDeliveryMethod.Home && (
                <Chip className={styleClassNames.errorChip} label='Missing address data' readonly={true} selected={true} variant='suggestion' />
              )}
              {(employee?.hireDate == null || employee.hireDate === '') && <Chip className={styleClassNames.errorChip} label='Missing hire date' readonly={true} selected={true} variant='suggestion' />}
              {(employee?.birthDate == null || employee.birthDate === '') && employee?.company?.employeeBirthdayActivated && (
                <Chip className={styleClassNames.errorChip} label='Missing birth date' readonly={true} selected={true} variant='suggestion' />
              )}
            </div>
          </div>
          <IconButton icon='close' onClick={closeModal} variant='standard' />
        </div>

        <div className={styles.header}>
          <NavigationTabs hideOutlet={true} className={styles.tabs} contentClassName={styles.tabsContent} options={options} />
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    </Modal>
  );
};
